import request from '@/utils/request'
const baseURL = '/jt-api'
export function delSamplingRule(id) {
  return request({
    url: '/jt808/samplingRule/' + id,
    baseURL,
    method: 'delete'
  })
}
